// solution-swiper.js
function initSolutionSwiper() {
  const sliderElement = document.querySelector(".solution_swiper");

  if (!sliderElement || sliderElement.swiper) return;

  const initSwiper = () => {
    if (typeof window.whenSwiperReady === 'function') {
      window.whenSwiperReady(function () {
        if (sliderElement.swiper) return;
        bootSwiper();
      });
      return;
    }
    if (typeof Swiper === 'undefined') {
      setTimeout(initSwiper, 100);
      return;
    }
    bootSwiper();
  };

  const bootSwiper = () => {
    if (sliderElement.swiper) return;

    const section = sliderElement.closest("section");
    const solutionSlideCount =
      sliderElement.querySelectorAll(".swiper-slide").length;

    new Swiper(sliderElement, {
      slidesPerView: 2,
      spaceBetween: 16,

      // Loop only when actually useful
      loop: solutionSlideCount > 4,

      navigation: {
        prevEl: section?.querySelector(".solution_swiper_prev"),
        nextEl: section?.querySelector(".solution_swiper_next"),
      },

      scrollbar: {
        el: section?.querySelector(".swiper-scrollbar"),
        draggable: true,
      },

      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 3.6,
          spaceBetween: 10,
        },
        1600: {
          slidesPerView: 3.6,
          spaceBetween: 40,
        },
      },
    });
  };

  const observer = new IntersectionObserver(
    (entries, observer) => {
      const entry = entries[0];

      if (!entry.isIntersecting) return;

      observer.unobserve(sliderElement);

      if ("requestIdleCallback" in window) {
        requestIdleCallback(initSwiper, {
          timeout: 1000,
        });
      } else {
        setTimeout(initSwiper, 0);
      }
    },
    {
      rootMargin: "300px 0px",
      threshold: 0,
    }
  );

  observer.observe(sliderElement);
}

initSolutionSwiper();